import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// import reportWebVitals from './reportWebVitals';

// React 18 version

/**
 * Wrapping in a DOMContentLoaded event to prevent react from executing
 * first and to make it independent of wp_enqueue_scripts load order (header / footer).
 */
document.addEventListener("DOMContentLoaded", function(event) {
    const rootElement = document.getElementById('cg-jobs-single-root');
    if(rootElement){
        const root = ReactDOM.createRoot(
            rootElement as HTMLElement
        );
        root.render(
            <React.StrictMode>
                <App />
            </React.StrictMode>,
        );
    }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
